// src/components/store/sections/hero-banner/HeroV50CathedralarchRoyalViolet.tsx
"use client";

import React from "react";
import DynamicHeroVariant from "./DynamicHeroVariant";

export default function HeroV50CathedralarchRoyalViolet(props: any) {
  return (
    <DynamicHeroVariant
      variantNumber={50}
      archKey="cathedral_arch"
      archLabel="Cathedral Arch Stage"
      palName="RoyalViolet"
      grad="from-violet-600 via-purple-600 to-indigo-700"
      lightBg="bg-violet-50"
      textCol="text-violet-700"
      borderCol="border-violet-200"
      btnCls="bg-violet-600 hover:bg-violet-700"
      {...props}
    />
  );
}
